import { Component } from '@angular/core';

@Component({
  selector: 'app-access-denied-page',
  template: `
    <div class="access-denied">
      <h2>Access Denied</h2>
      <p>You do not have permission to view this page.</p>
    </div>
  `,
  styles: [`
    .access-denied {
      text-align: center;
      margin-top: 80px;
      color: #c00;
    }
  `]
})
export class AccessDeniedPageComponent {}
